import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=751ecd7e&scoped=true&lang=pug"
import script from "./Create.vue?vue&type=script&lang=ts"
export * from "./Create.vue?vue&type=script&lang=ts"
import style0 from "./Create.vue?vue&type=style&index=0&id=751ecd7e&prod&lang=scss&scoped=true"
import style1 from "./Create.vue?vue&type=style&index=1&id=751ecd7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751ecd7e",
  null
  
)

export default component.exports